import { render } from "./LanguageSelector.vue?vue&type=template&id=bdc8e8d6&scoped=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"

import "./LanguageSelector.vue?vue&type=style&index=0&id=bdc8e8d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc8e8d6"],['__file',"src/components/list-items/LanguageSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bdc8e8d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bdc8e8d6', __exports__)) {
    api.reload('bdc8e8d6', __exports__)
  }
  
  module.hot.accept("./LanguageSelector.vue?vue&type=template&id=bdc8e8d6&scoped=true", () => {
    api.rerender('bdc8e8d6', render)
  })

}


export default __exports__